/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.13.0
 * @since 1.13.0
 */

import { SkeletonParagraph } from '../../../../../components/common';
import { ESkeletonKind } from '../../../../../components/common/Skeleton/skeletonTypes';
import { SubscriberIdSkeletonStyled } from '../../styled/PageSubscriberIdStyled';
import { SubscriberIdAdditionalAccountsStyled } from './styled/SubscriberIdAdditionalAccountsStyled';

const btnStyle = { width: 200, marginTop: 16 };

const SubscriberIdAdditionalAccountsSkeleton = () => {
    return (
        <SubscriberIdAdditionalAccountsStyled>
            <SubscriberIdSkeletonStyled className="subscriber-id-additional-accounts__block">
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                <SkeletonParagraph className="subscriber-id-additional-accounts__content"
                                   kind={ESkeletonKind.PARAGRAPH_NORMAL}/>
                <SkeletonParagraph kind={ESkeletonKind.BUTTON_ROUND} style={btnStyle}/>
            </SubscriberIdSkeletonStyled>

            <SubscriberIdSkeletonStyled className="subscriber-id-additional-accounts__block">
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL}/>
                <SkeletonParagraph className="subscriber-id-additional-accounts__content"
                                   kind={ESkeletonKind.PARAGRAPH_NORMAL}/>
                <SkeletonParagraph kind={ESkeletonKind.BUTTON_ROUND} style={btnStyle}/>
            </SubscriberIdSkeletonStyled>
        </SubscriberIdAdditionalAccountsStyled>
    );
};

export default SubscriberIdAdditionalAccountsSkeleton;
